import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import { FaStar, FaGoogle } from 'react-icons/fa';
import 'swiper/css';
import 'swiper/css/navigation';

// Japanese names aur dummy images (aap image path yahan update kar sakte hain)
const reviews = [
    { name: "Tanaka Kenji", text: "Nice service", date: "5 months ago", img: "/j1.jpg" },
    { name: "Sato Haruka", text: "Raj Kuruma is a very good service company. I booked a package...", date: "5 months ago", img: "/j2.jpg" },
    { name: "Suzuki Hiroshi", text: "Thanks a lot to Raju san, my experience in India was great...", date: "5 months ago", img: "/j3.jpg" },
    { name: "Takahashi Yuki", text: "Very nice company and good services", date: "5 months ago", img: "/j4.jpg" },
    { name: "Watanabe Akiko", text: "Very good service", date: "5 months ago", img: "/j5.jpg" },
    { name: "Ito Daiki", text: "Nice", date: "5 months ago", img: "/j6.jpg" }
];

const Testimonials = () => {
    return (
        <section className="py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-6">
                {/* Section title */}
                <h2 className="text-4xl font-extrabold text-gray-900 text-center mb-12">What customer say about Our services</h2>

                <Swiper
                    modules={[Autoplay, Navigation]}
                    spaceBetween={20}
                    slidesPerView={1}
                    breakpoints={{ 768: { slidesPerView: 3 } }}
                    loop={true}
                    navigation={true}
                    autoplay={{ delay: 3000 }}
                >
                    {reviews.map((rev, index) => (
                        <SwiperSlide key={index}>
                            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 h-64 flex flex-col justify-between">
                                {/* Top part with name and icon */}
                                <div className="flex justify-between items-start">
                                    <div className="flex items-center gap-3">
                                        <img src={rev.img} alt={rev.name} className="w-10 h-10 rounded-full object-cover" />
                                        <div>
                                            <h4 className="font-bold text-sm">{rev.name}</h4>
                                            <p className="text-xs text-gray-400">{rev.date}</p>
                                        </div>
                                    </div>
                                    <FaGoogle className="text-blue-500" />
                                </div>

                                {/* Star ratings */}
                                <div className="flex text-yellow-400 text-xs my-2">
                                    {[...Array(5)].map((_, i) => <FaStar key={i} />)}
                                </div>

                                {/* Review text */}
                                <p className="text-gray-600 text-sm italic">{rev.text}</p>

                                {/* Read more button */}
                                <button className="text-gray-400 text-xs text-left hover:underline">Read more</button>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

                {/* Verification badge */}
                <div className="text-center mt-10">
                    <span className="bg-[#0b6623] text-white px-4 py-2 rounded text-sm font-bold flex items-center justify-center gap-2 w-max mx-auto">
                        Verified by Trustindex <span className="text-xs">ⓘ</span>
                    </span>
                </div>
            </div>
        </section>
    );
};

export default Testimonials;